import { MenuSettingsConfiguration, SettingsDataValues } from './types';
import { ToolbarButtonData } from '@se/platform';
import { isNil } from 'lodash-es';

export const parseSettingsDataValues = (
    data: SettingsDataValues,
    settingsConfig: MenuSettingsConfiguration[],
): SettingsDataValues => {
    const parsed = { ...data };
    settingsConfig.forEach(({ id, settings }) => {
        if (!parsed[id]) {
            parsed[id] = {};
        }
        parsed[id] = { ...data[id] };

        settings.forEach((setting) => {
            if (typeof parsed[id][setting.name] !== setting.type) {
                parsed[id][setting.name] = setting.defaultValue;
            }
        });
    });
    return parsed;
};

export const toolbarToMenuSettings = (toolbar: ToolbarButtonData[]): SettingsDataValues => {
    return Object.fromEntries(
        toolbar.map((btn, _index) => [
            btn.actionType,
            {
                visibilityToolbar: !isNil(btn.status.visibleIntoToolbar)
                    ? btn.status.visibleIntoToolbar
                    : btn.status.visible,
                visibilityContext: !isNil(btn.status.visibleIntoContext)
                    ? btn.status.visibleIntoContext
                    : btn.status.visible,
            },
        ]),
    );
};
